<div class="account-pages my-5 pt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5">
            <h1 class="display-2 fw-medium">
              4<i class="bx bx-buoy bx-spin text-primary display-3"></i>4
            </h1>
            <h4 class="text-uppercase">Sorry, page not found</h4>
            <div class="mt-5 text-center">
              <a class="btn btn-primary" routerLink="/">Back to Home</a>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Shooting Game -->
      <div class="row justify-content-center mt-5">
        <div class="col-md-8 col-xl-6 text-center">
          <canvas
            #gameCanvas
            width="400"
            height="400"
            style="border:1px solid #ccc; background:#f8f9fa;"
          ></canvas>
          <p class="mt-2">🎮 ⬅️ ➡️ move, Spacebar to shoot!</p>
        </div>
      </div>
    </div>
  </div>
  